/* eslint-disable indent */
import urls from "../../api/urls";
import NormalAPI from "../../api";

const { GET_ALL_HUBS_PENDING_AWBS, GET_UNBOOKED_SHIPMENTS_DETAILS, CLEAR_UNBOOKED_SHIPMENTS, GET_HUB_PENDING_AWBS } = urls;

export const LockingService = {
    getAllHubsPendingAwbs: async (params) => {
        try {
            const response = await NormalAPI.Api(GET_ALL_HUBS_PENDING_AWBS).getwithParams(params);
            if (response?.status) {
                return response?.response?.data || {};
            }
            throw new Error(response?.response?.data?.message || "Failed to fetch hubs pending AWBs");
        } catch (error) {
            console.error("Error in LockingService.getAllHubsPendingAwbs:", error);
            throw error;
        }
    },

    getUnbookedShipmentsDetails: async (awbs) => {
        try {
            const response = await NormalAPI.Api(GET_UNBOOKED_SHIPMENTS_DETAILS).getwithParams({ awbs });
            console.log("Service response for unbooked shipments:", response);
            if (response?.status) {
                return response?.response?.data;
            }
            throw new Error(response?.response?.data?.message || "Failed to fetch unbooked shipment details");
        } catch (error) {
            console.error("Error in LockingService.getUnbookedShipmentsDetails:", error);
            throw error;
        }
    },

    clearUnbookedShipments: async (data) => {
        try {
            const response = await NormalAPI.Api(CLEAR_UNBOOKED_SHIPMENTS).post(data);
            if (response?.status) {
                return response?.response?.data;
            }
            throw new Error(response?.response?.data?.message || "Failed to clear unbooked shipments");
        } catch (error) {
            console.error("Error in LockingService.clearUnbookedShipments:", error);
            throw error;
        }
    },

    getHubPendingAwbs: async (hubId) => {
        try {
            const response = await NormalAPI.Api(GET_HUB_PENDING_AWBS).getwithParams({ hub_id: hubId });
            if (response?.status) {
                return response?.response?.data;
            }
            throw new Error(response?.response?.data?.message || "Failed to fetch hub pending AWBs");
        } catch (error) {
            console.error("Error in LockingService.getHubPendingAwbs:", error);
            throw error;
        }
    },
    
    applySelectiveExtension: async (data) => {
        try {
            const response = await NormalAPI.Api(urls.APPLY_SELECTIVE_EXTENSION).post(data);
            if (response?.status) {
                return response?.response?.data;
            }
            throw new Error(response?.response?.data?.message || "Failed to apply selective extension");
        } catch (error) {
            console.error("Error in LockingService.applySelectiveExtension:", error);
            throw error;
        }
    },
};
